import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  srConfigsByLevel: null,
  srConfigsByLevelLoading: false,
  srConfigsByLevelError: false,
  penaltiesError: false,

  successRates: null,
  successRatesError: false,
  successRatesLoading: false,
  refreshSuccessRates: true,
  noMoreSuccessRate: false,

  // success rates list
  totalSuccessRates: null,
  successRatespage: 0,
  successRatesperPage: 10,
  currentMonth: null

}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
